export const IS_LIVE_CHANGED = 'IS_LIVE_CHANGED';

export const isLiveChanged = () => ({
    type: IS_LIVE_CHANGED,
    payload: true
});



// WEBPACK FOOTER //
// ./src/store/actions/is-live.js